module.exports = __webpack_public_path__ + "static/img/03.7bccc4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/eggenberger/03.jpg
// module id = 363
// module chunks = 1